import { isSecondaryMarketQuotesDlpOrderPersistedTabContent } from 'apiConnector/tabs/secondaryMarket.tabs.model';
import type { Action } from 'state/actions';
import { addKey, patchKey, removeKey } from 'state/utils/collection';

import type { SecondaryMarketDlpOrderForm } from './dlpOrderForm.model';
import { initialDlpOrderForm, initialSecondaryMarketDlpOrderForm } from './dlpOrderForm.model';

export function dlpOrderFormReducer(
  state: SecondaryMarketDlpOrderForm = initialDlpOrderForm,
  action: Action,
): SecondaryMarketDlpOrderForm {
  switch (action.type) {
    case 'WORKSPACE_TAB_CREATED':
      if (action.tabType === 'dlpProducts') {
        return addKey(state, action.id, initialSecondaryMarketDlpOrderForm);
      }
      return state;
    case 'WORKSPACE_TABS_FETCHED':
      if (action.workspace === 'secondaryMarketQuotes') {
        const tabs = action.tabs.filter(t => t.type === 'dlpProducts');
        return tabs.reduce(
          (currentState, tab) => addKey(currentState, tab.id, initialSecondaryMarketDlpOrderForm),
          state,
        );
      }
      return state;
    case 'WORKSPACE_TAB_REMOVED':
      if (action.workspace === 'secondaryMarketQuotes') {
        return removeKey(state, action.id);
      }
      return state;

    case 'WORKSPACE_TAB_CONTENT_FETCHED':
      if (isSecondaryMarketQuotesDlpOrderPersistedTabContent(action.tabContent)) {
        const { workspace: _workspace, tabType: _tab, ...formData } = action.tabContent;
        return patchKey(state, action.tabId, _ => formData);
      }
      return state;
    case 'SECONDARY_MARKET_DLP_ORDER_FORM_FIELD_CHANGED':
      return patchKey(state, action.tabId, () => ({ [action.field]: action.value }));

    default:
      return state;
  }
}
